<div class="header">
  <div class="header__brand">
    <span>VÍVELA</span>
  </div>

  <vv-button color="light"> Crear cuenta </vv-button>
</div>
